var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-team-multi-picker"},[_c('i-multi-picker',{attrs:{"label-counter":"shared drive(s)","label":_vm.label,"value":_vm.value,"fetch-options":_vm.fetchSharedDrives,"option-label":"name","option-value":"id"},on:{"input":$val => _vm.$emit('input',$val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }